import type React from "react";

import { AssetToken } from "./chat-tokens/AssetToken";
import { ProductToken } from "./chat-tokens/ProductToken";

export const CHAT_TOKEN_REGISTRY: Record<string, React.FC<{ data: any }>> = {
  product: ProductToken,
  asset: AssetToken,
};
